"use client";

import { Icons } from "@/components/icons";
import { useEffect, useState } from "react";

export function GoogleButton({ redirect }: { redirect: string }) {
  const [origin, setOrigin] = useState("");
  useEffect(() => setOrigin(window.location.origin), []);

  return (
    <a
      href={`${process.env.NEXT_PUBLIC_CORE_BASEURL}/auth/google/redirect?redirect_url=${encodeURIComponent(origin + redirect)}`}
      className="flex h-12 w-full items-center justify-center gap-3 rounded-lg bg-white text-base font-medium text-[#3c4043] transition-colors hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-accent focus-visible:ring-offset-2 focus-visible:ring-offset-theme-black3"
    >
      <Icons.google className="h-6 w-6" />
      Masuk dengan Google
    </a>
  );
}
